import React, { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { getUserDomainAccess } from '../services/masterDataService';
import { THEME } from '../theme/themeColors';

const ViewUserDomainsModal = ({ show, onClose, user }) => {
  const [domains, setDomains] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show || !user) return;

    const userId = user.szUserId || user.userId;
    const currentDomain = sessionStorage.getItem('selectedDomain') || 'greenyourbills.com';

    const load = async () => {
      setLoading(true);
      try {
        const data = await getUserDomainAccess(userId, currentDomain);
        // GetDomainsByUserId already filters Status = 1 server-side,
        // so everything returned here is an active mapping.
        setDomains(data || []);
      } catch (err) {
        toast.error('Failed to load domain access');
        setDomains([]);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [show, user]);

  if (!show) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.65)', zIndex: 1060,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '12px'
    }} onClick={onClose}>

      <div style={{
        width: '100%', maxWidth: '440px', background: 'white', borderRadius: '10px',
        overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
      }} onClick={e => e.stopPropagation()}>

        {/* Themed Header */}
        <div style={{
          backgroundColor: THEME.primary, padding: '12px 16px',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center'
        }}>
          <div>
            <div style={{ color: THEME.onPrimary, fontWeight: 700, fontSize: '15px' }}>Active Domains</div>
            <div style={{ color: THEME.onPrimary, opacity: 0.9, fontSize: '12.5px', marginTop: '1px' }}>
              {user?.szUserName || user?.userName}
            </div>
          </div>
          <button
            onClick={onClose}
            aria-label="Close"
            style={{ fontSize: '26px', background: 'none', border: 'none', color: THEME.onPrimary }}
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: '14px 16px', maxHeight: '55vh', overflowY: 'auto' }}>
          {loading ? (
            <div className="text-center text-muted py-4" style={{ fontSize: '12px' }}>
              <span className="spinner-border spinner-border-sm me-2" style={{ color: THEME.primary }} />
              Loading...
            </div>
          ) : domains.length === 0 ? (
            <div className="text-center text-muted py-4" style={{ fontSize: '12.5px' }}>
              No active domains for this user
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {domains.map((d) => (
                <div
                  key={d.domainId}
                  style={{
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    padding: '10px 12px', borderRadius: '8px', background: '#f8f9fa',
                    border: '1px solid #eef0f1',
                  }}
                >
                  <span style={{ fontSize: '13px', fontWeight: 500, color: '#1f2937' }}>
                    {d.domainName}
                  </span>
                  <span style={{
                    fontSize: '11px', fontWeight: 700, padding: '4px 10px', borderRadius: '999px',
                    color: THEME.primaryHover, background: THEME.primaryLight,
                  }}>
                   {d.isReadWrite ? 'READ & WRITE' : 'READ ONLY'}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Compact Footer */}
        <div style={{
          padding: '10px 16px', borderTop: '1px solid #eef0f1',
          display: 'flex', justifyContent: 'flex-end', background: '#fafafa'
        }}>
          <button
            onClick={onClose}
            style={{
              padding: '6px 20px', background: '#6c757d', color: 'white',
              border: 'none', borderRadius: '6px', fontSize: '13px'
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewUserDomainsModal;